import type {Diagnostic} from '@codemirror/lint'
import type {KeyValue} from '@jetbrains/teamcity-ui/dist/utils'

import type {BuildId, PipelineId} from '../../../../../types'
import type {NewPipeline, Pipeline} from '../../services/pipelinesApi.types'
import type {PipelineDependencyDetails, PipelineDependencyId} from '../../types'

export type PipelineDraft = {
  original?: Pipeline
  draft?: NewPipeline
  isCollisionApi?: boolean
  deleted?: {
    jobs?: string[]
    jobParameters?: string[]
    outputParameters?: string[]
    filesPublication?: string[]
    parameters?: string[]
    steps?: Record<string, number[]>
    integrations?: string[]
    secrets?: string[]
    additionalVcsRoots?: string[]
    incompleteAdditionalVcsRoots?: number[]
    notifications?: string[]
    dependencies?: string[]
  }
  renamed?: {
    outputParameters?: Record<string, string>
    jobParameters?: Record<string, string>
    parameters?: Record<string, string>
    integrations?: Record<string, string>
    secrets?: Record<string, string>
    notifications?: Record<string, boolean>
  }
  reordered?: {
    steps?: Record<string, number[]>
  }
  added?: {
    outputParameters?: Record<string, boolean>
    jobParameters?: Record<string, boolean>
    filesPublication?: Record<string, boolean>
    parameters?: Record<string, boolean>
    secrets?: Record<string, boolean>
    notifications?: Record<string, boolean>
    dependencies?: Record<string, boolean>
  }
}

// Settings are stored per pipeline AND per branch. The default branch or pipelines without stored YAML
// settings use the canonical `<default>` key (DEFAULT_NAME from branchNames.ts).
export type PipelineDraftState = KeyValue<string, KeyValue<string, PipelineDraft>>

export type PipelineDebug = {
  isRunning?: boolean
  isPanelOpen?: boolean
  isPanelExpanded?: boolean
  runId?: BuildId | null
  jobId?: string | null
  yaml?: string | null
}

// Per pipeline AND per branch, mirroring the draft store. Default branch → `<default>` key.
export type PipelineDebugState = KeyValue<PipelineId, KeyValue<string, PipelineDebug>>

export type PipelineYamlDraft = {yaml?: string; diagnostics?: Diagnostic[]}
export type PipelineYamlDraftState = KeyValue<PipelineId, KeyValue<string, PipelineYamlDraft>>

export type PipelineYamlValidity = {isParsed: boolean; yaml?: string}
export type PipelineYamlValidityState = KeyValue<PipelineId, KeyValue<string, PipelineYamlValidity>>

export type PipelineDependencyDetailsState = Record<
  PipelineId,
  Record<string, Record<PipelineDependencyId, PipelineDependencyDetails>>
>

export type JobDependencyGuideState = {
  pipelineId: PipelineId
  branch: string
  jobId: string
} | null

export enum FormType {
  PIPELINE_INTEGRATION = 'pipelineIntegration',
  BLOCK_HEADER = 'blockHeader',
  REPOSITORY = 'repository',
  REPOSITORIES = 'repositories',
  NAME = 'name',
  STEP = 'step',
  PARAMETER = 'parameter',
  OUTPUT_PARAMETER = 'outputParameter',
  JOB_PARAMETER = 'jobParameter',
  SECRET = 'secret',
  TRIGGER = 'trigger',
  DEPENDENCY = 'dependency',
  BUILD_FEATURE = 'buildFeature',
}

type PipelineFormState = {
  open: boolean
  isAdd?: boolean
}
export type PipelineFormsState = KeyValue<string, KeyValue<string, PipelineFormState>>
export type PipelineFormParams = {
  pipelineId: PipelineId
  branch: string
  jobId?: string | null
  id?: string | number
  type: FormType
  isAdd?: boolean
}
